import * as React from 'react';

function SvgReminderIcon(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 .875a6.125 6.125 0 100 12.25A6.125 6.125 0 007 .876zm.438 9.078c0 .06-.05.11-.11.11h-.656a.11.11 0 01-.11-.11V6.234c0-.06.05-.109.11-.109h.656c.06 0 .11.05.11.11v3.718zM7 5.25a.656.656 0 010-1.313.656.656 0 010 1.313z"
        fill="#FA8C16"
      />
    </svg>
  );
}

export default SvgReminderIcon;
